import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { LOGO_BLACK } from "../data/content";
import { GrainButton } from "./GrainButton";
import { openInquiry, scrollToId } from "../lib/scroll";

export const TopHeader = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="top-header"
      className={`sticky top-0 z-40 transition-all duration-500 ${
        scrolled ? "bg-cream/85 backdrop-blur-xl border-b border-charcoal/[0.06]" : "bg-cream"
      }`}
    >
      <div className="grid grid-cols-3 items-center px-4 sm:px-8 py-3.5 max-w-[1700px] mx-auto">
        <span
          data-testid="header-license"
          className="font-mono text-[9px] sm:text-[11px] tracking-[0.16em] text-charcoal/55"
        >
          CA LIC. #667661
        </span>
        <div className="justify-self-center">
          <img
            src={LOGO_BLACK}
            alt="Nagel Landscaping"
            data-testid="header-logo"
            onClick={() => scrollToId("home")}
            className="h-7 sm:h-9 w-auto cursor-pointer transition-transform duration-500 hover:scale-[1.03]"
          />
        </div>
        <div className="justify-self-end">
          <GrainButton small testid="send-inquiry-header-button" onClick={() => openInquiry()}>
            <span className="hidden sm:inline">SEND INQUIRY</span>
            <span className="sm:hidden">INQUIRY</span>
            <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </GrainButton>
        </div>
      </div>
    </header>
  );
};
